<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="i_khid" :label="$t('creditManagement_customer_name')" required>
                <span v-if='data.i_id!=0'>{{formData.vc_khname}}</span>
                <el-select v-else style="width: 200px" @change="changekh" class="marr4" v-model="formData.i_khid" size="mini" remote :remote-method="remoteMethodkh" filterable :placeholder="$t('creditManagement_please_select_customer')">
                    <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="vc_khcode" :label="$t('creditManagement_enterprise_code')">
                <span v-if='data.i_id!=0||(data.i_id==0&&formData.i_bzid!=2)'>{{formData.vc_khcode}}</span>
                <el-input v-else :disabled="canEdit" class="changeinput"  size="mini" v-model="formData.vc_khcode" ></el-input>
            </el-form-item>
            <el-form-item  prop="i_bzid" :label="$t('creditManagement_currency')" required>
                <span  v-if='data.i_id!=0'>{{formData.vc_bzname}}</span>
                <el-select v-else  :disabled="canEdit"  style="width: 100px"  @change="changebz"  class="marr4"  v-model="formData.i_bzid" size="small"  :placeholder="$t('creditManagement_please_select_currency')">
                    <el-option v-for="item in bzList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="f_sxed" :label="$t('creditManagement_total_credit_limit')" required>
                <span v-if='data.i_id!=0'>{{formData.f_sxed}}</span>
                <el-input-number v-else :disabled="canEdit" v-model="formData.f_sxed" class="changeinput" :controls="false" :precision="2" :min="0" size="mini"  ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_insure" :label="$t('creditManagement_insured_portion')" required>
                <span v-if='data.i_id!=0'>{{formData.f_insure}}</span>
                <el-input-number v-else :disabled="canEdit" v-model="formData.f_insure" @change="tbChange" class="changeinput" :controls="false" :precision="2" :min="0" size="mini" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="i_sxts" :label="$t('creditManagement_credit_term_days')" required>
                <span v-if='data.i_id!=0'>{{formData.i_sxts}}</span>
                <el-input-number v-else :disabled="canEdit" v-model="formData.i_sxts" class="changeinput" :controls="false" :precision="0" :min="0" size="mini" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="i_flag" :label="$t('creditManagement_type')" required>
                <span v-if='data.i_id!=0'>{{formData.i_flag?$t('creditManagement_fixed'):$t('creditManagement_temporary')}}</span>
                <el-radio-group v-else :disabled="canEdit" v-model="formData.i_flag" @input="changeLX">
                    <el-radio :label=1>{{$t('creditManagement_fixed')}}</el-radio>
                    <el-radio :label=0>{{$t('creditManagement_temporary')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item  prop="dt_expiredate" :label="$t('creditManagement_expiry_date')" required>
                <span  v-if='data.i_id!=0'>{{formData.dt_expiredate}}</span>
                <el-date-picker v-else :disabled="canEdit" v-model="formData.dt_expiredate" size="mini"  format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" type="date" :placeholder="$t('creditManagement_select_date')"></el-date-picker>
            </el-form-item>
            <el-form-item  prop="vc_note" :label="$t('form_notes')">
                <span  v-if='data.i_id!=0'>{{formData.vc_note}}</span>
                <el-input v-else :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_note"  ></el-input>
            </el-form-item>
            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_enter_time')" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm"  v-if='data.i_id==0' :disabled="disabled" :class="baseerp+'btn'" size="small" >{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                baseerp:'',
                canEdit:false,
                formData:{
                    vc_khcode:'',
                    vc_khname:'',
                    i_khid:'',
                    f_sxed:0,
                    i_sxts:0,
                    i_flag:1,
                    f_insure:0,
                    f_kyed:0,
                    dt_expiredate:0,
                    dt_createtime:0,
                    vc_lruname:0,
                    i_bzid:1,
                    vc_bzname:this.$t('creditManagement_rmb'),
                    vc_note:'',
                },
                gsList:[],
                yhzhList:[],
                khList:[],
                gysList:[],
                tableHeight:0,
                searchkh:'',
                bzList:[],
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.formData=JSON.parse(JSON.stringify(this.data))
            if(this.data.i_id==0){
                this.canEdit=false;
                this.now=this.$DateTime.now();
                if(this.formData.i_flag){
                    let nexty=this.now.plus({years:1});
                    this.formData.dt_expiredate=nexty.toFormat('yyyy-MM-dd');
                }else{
                    this.formData.dt_expiredate=this.now.toFormat('yyyy-MM-dd');
                };
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');
                this.formData.vc_lruname=sessionStorage.getItem("lruname");
                this.formData.i_lruid=sessionStorage.getItem("userid");
                // console.log(nexty.toFormat('yyyy-MM-dd'),'foemate')
                this.searchkh=this.formData.vc_khname;
                this.getKhlistWithNoRights();
                this.getbzlist();
            }else{
                this.canEdit=true;
            }
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },

            cancel(){
                this.$emit('close')
            },
            changeLX(e){
                this.formData.i_flag=e;
                if(this.formData.i_flag){
                    let nexty=this.now.plus({years:1});
                    this.formData.dt_expiredate=nexty.toFormat('yyyy-MM-dd');
                }else{
                    this.formData.dt_expiredate=this.now.toFormat('yyyy-MM-dd');
                };
                this.$forceUpdate();
            },
            tbChange(){
                if(this.formData.f_insure>this.formData.f_sxed) {
                    this.$message.warning(this.$t('creditManagement_the_insured_amount_cannot_exceed_the_total_limit'));
                    this.formData.f_insure=0;
                    this.$forceUpdate();
                }
            },
            changebz(){
                let gsobj=this.bzList.find(gs => gs.i_id == this.formData.i_bzid);
                this.formData.vc_bzname = gsobj.vc_name;
                if((this.formData.i_bzid==1||this.formData.i_bzid==2)&&this.formData.i_khid){
                    this.getCompanyCode();
                }
            },
            changekh(){
                if(this.formData.i_khid) {
                    let gsobj=this.khList.find(gs => gs.i_id == this.formData.i_khid);
                    this.formData.vc_khname = gsobj.vc_name;
                    if(this.formData.i_bzid==1||this.formData.i_bzid==2){
                        this.getCompanyCode();
                    }
                }
            },
            remoteMethodkh(val){
                this.searchkh=val;
                this.getKhlistWithNoRights();
            },
            async getKhlistWithNoRights(){
                let param={
                    i_khtype:1,
                    currentPage:1,
                    pageSize: 50,
                    vc_search: this.searchkh,
                };
                let res=await API.getKhlistWithNoRights(param);
                if ( res.code == 1 ){
                    this.khList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyCode(){
                let param={
                    i_khid:this.formData.i_khid,
                    vc_khname:this.formData.vc_khname,
                };
                let res=await API.getCompanyCode(param);
                if ( res.code == 1 ){
                    this.formData.vc_khcode=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            saveForm(){
                // console.log(this.formData,'this.formData')
                if(this.formData.f_sxed){

                }else{
                    this.$message.warning(this.$t('creditManagement_total_credit_limit_cannot_be_zero'))
                    return
                }
                if(this.formData.i_khid){}else{
                    this.$message.warning(this.$t('creditManagement_please_select_customer'))
                    return
                }
                this.$confirm(this.$t('creditManagement_cannot_edit_after_saving_do_you_want_to_continue'),this.$t('creditManagement_prompt'),{
                    confirmButtonText:this.$t('creditManagement_continue'),
                    cancelButtonText:this.$t('creditManagement_cancel'),
                    type:'warning'
                }).then(async()=>{
                    this.saveCredit()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:this.$t('creditManagement_cancelled')
                    })
                })
            },
            async saveCredit(){
                let param=this.formData;
                let res=await API.saveCredit(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>